// extracted by mini-css-extract-plugin
export var actionButton = "_em-0";
export var attachmentLine = "_em-1";
export var fileInput = "_em-2";
export var fileUploadWrapper = "_em-4";
export var footer = "_em-3";
export var modalContent = "_em-5";
export var paperclip = "_em-6";
export var quillEditor = "_em-7";